import { Component, OnInit,ElementRef, ViewChild } from '@angular/core';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { AdministrationService } from 'src/app/services/administration/administration.service';


@Component({
  selector: 'app-school-information',
  templateUrl: './school-information.component.html',
  styleUrls: ['./school-information.component.css']
})
export class SchoolInformationComponent implements OnInit {

  ClassList: any;
  Submitted: boolean = false;
  SelectedFileForUpload: any;
  @ViewChild('fileUploader', { static: false }) fileUploader: ElementRef;
  constructor(private adminservice: AdministrationService, private lookupservice: LookupService,
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService,private lookupService:LookupService) { }

  SchoolInformationModel = {
    SchoolInformationID: 0,
    SchoolInfoCategoryID:0,
    SchoolInformation: '',
    IsActive: true,
    DisplayOrder:0,
    SchoolInformationFile:'',
  };

  Clear() {
    this.SchoolInformationModel.SchoolInfoCategoryID = 0;
    this.SchoolInformationModel.SchoolInformationID = 0;
    this.SchoolInformationModel.SchoolInformation = '';
    this.SchoolInformationModel.SchoolInformationFile = '';
    this.Submitted = false;
    if(this.SelectedFileForUpload!=undefined && this.SelectedFileForUpload!=null){
      this.fileUploader.nativeElement.value = null;
      this.SelectedFileForUpload=null;
    }
  };

  SchoolInformationList=[];
  GetSchoolInformation() {
    this.spinnerService.show();
    this.adminservice.GetSchoolInformation().subscribe((response: any) => {     
      this.SchoolInformationList = response.SchoolInformation;
      this.spinnerService.hide();
      this.globalHelper.CheckActionStatus(response);

    });
  };

  selectFileforUpload(file) {
    this.SelectedFileForUpload = file[0];
  };



  SaveSchoolInformation(valid) {
    this.Submitted = true;
    if (valid) {
      this.spinnerService.show();
      this.adminservice.SaveSchoolInformation(JSON.stringify(this.SchoolInformationModel), this.SelectedFileForUpload).subscribe((data: any) => {
        if (data.webResponse.Status && this.SchoolInformationModel.SchoolInformationID == 0) {
          this.Clear();

        }      
        this.Submitted = false;
        if(this.SelectedFileForUpload!=undefined && this.SelectedFileForUpload!=null){
          this.fileUploader.nativeElement.value = null;
          this.SelectedFileForUpload=null;
        }
        this.GetSchoolInformation();
        this.spinnerService.hide();
        this.globalHelper.CheckActionStatus(data);

      });
    }
  }

  Edit(obj) {
    this.SchoolInformationModel.SchoolInfoCategoryID = obj.SchoolInfoCategoryID;
    this.SchoolInformationModel.SchoolInformationID = obj.SchoolInformationID;
    this.SchoolInformationModel.SchoolInformation = obj.SchoolInformation;
    this.SchoolInformationModel.SchoolInformationFile = obj.SchoolInformationFile;

  };
  SchoolInfoCategoryList={};
  GetSchoolInfoCategory  () {
    this.lookupService.GetLookupsList('SchoolInfoCategory', '').subscribe( (data)=> {
       this.SchoolInfoCategoryList = data.LookupItems;
   });
};
  ngOnInit() {
    this.GetSchoolInfoCategory();
    this.GetSchoolInformation();
  }

  // Delete 

  DeleteSchoolInformation(item) {   
    if (confirm("Are you sure to delete the school information !")) {
      this.spinnerService.show();
      this.adminservice.DeleteSchoolInformation(item.SchoolInformationID).subscribe((data: any) => {
        if (data.webResponse.Status) {
          this.GetSchoolInformation();         
        }

        this.globalHelper.CheckActionStatus(data);
        this.spinnerService.hide();
      });
    }

  };

 
}






